import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguageStore, Language, languageNames } from "@/stores/languageStore";

const languageFlags: Record<Language, string> = {
  he: '🇮🇱',
  en: '🇺🇸',
  ar: '🇸🇦',
  ru: '🇷🇺',
};

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguageStore();

  // Arabic removed from UI; keep only supported languages in the selector.
  const languages: Language[] = ['he', 'en', 'ru'];

  const handleLanguageChange = (lang: Language) => {
    console.log('Changing language to:', lang);
    setLanguage(lang);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative text-white hover:bg-white/20 border border-white/30 hover:border-white/50" aria-label="Change language">
          <Globe className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="min-w-[140px] z-[100] bg-popover"
        sideOffset={8}
      >
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onSelect={() => handleLanguageChange(lang)}
            className={`cursor-pointer gap-2 ${language === lang ? 'bg-primary/10 text-primary font-medium' : ''}`}
          >
            <span>{languageFlags[lang]}</span>
            <span>{languageNames[lang]}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
